
import React from "react";
import "./about.css";

export function About() {
  return (
      <main className='about-main'>
          <div className="about-content">
              <div className="about-terminal-header">
                  <span className="about-terminal-title">// lightning.io --help</span>
              </div>
              <div className="about-body">
                  <p className="about-command"><span className="prompt">&gt;</span> DESCRIPTION</p>
                  <p className="about-text">
                      ephemeral file transfer terminal. upload any file or text snippet, receive a
                      shareable link and qr code instantly. files self-destruct after download or
                      after 2 hours — whichever comes first. no special app required on the receiving end.
                  </p>

                  <p className="about-command"><span className="prompt">&gt;</span> FEATURES</p>
                  <ul className="about-features">
                      <li><span className="feature-status">[OK]</span> secure https transfer</li>
                      <li><span className="feature-status">[OK]</span> drag-and-drop file upload</li>
                      <li><span className="feature-status">[OK]</span> text snippet sharing</li>
                      <li><span className="feature-status">[OK]</span> qr code generation</li>
                      <li><span className="feature-status">[OK]</span> public / private visibility toggle</li>
                      <li><span className="feature-status">[OK]</span> real-time download notifications via websocket</li>
                      <li><span className="feature-status">[OK]</span> pwa — installable on any platform</li>
                      <li><span className="feature-status">[OK]</span> auto-expiry: 2hr or on first download</li>
                  </ul>

                  <p className="about-command"><span className="prompt">&gt;</span> PLATFORMS</p>
                  <p className="about-text platform-list">
                      windows [////] &nbsp; macos [////] &nbsp; linux [////] &nbsp; ios [////] &nbsp; android [////]
                  </p>

                  <p className="about-command"><span className="prompt">&gt;</span> EXPIRY POLICY</p>
                  <p className="about-text">
                      files are purged after 2 hours or upon first download. no data is retained
                      beyond that window. no account required to receive or download files.
                  </p>
              </div>
          </div>
      </main>
  );
}